import React from "react";
import { Link } from "react-router-dom";

import IconButton from "@material-ui/core/IconButton";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

export default function HeaderDrawer(props) {

	var strHeaderTitle = "";

	//alert(JSON.stringify(props));

	if (props.headerTitle === undefined || props.headerTitle === null) {
		strHeaderTitle = "��å";
	}
	else {
		strHeaderTitle = props.headerTitle;
	}

	const [state, setState] = React.useState({
		headerTitle: strHeaderTitle
	});

	return (
		<React.Fragment>
			<header className="header">
				<div className="header-left">
					<IconButton>
						<KeyboardBackspaceIcon />
					</IconButton>
				</div>

				<h1 className="header-title">
					<Link to="/">{state.headerTitle}</Link>
				</h1>

			</header>
		</React.Fragment>
	);
}
